module.exports = __webpack_public_path__ + "static/portfolio-3-62f2256fe43e83ddb4923d1442efebec.jpg";